export const GET_ADMIN_PRODUCTS_REQUEST = "GET_ADMIN_PRODUCTS_REQUEST";
export const GET_ADMIN_PRODUCTS_SUCCESS = "GET_ADMIN_PRODUCTS_SUCCESS";
export const GET_ADMIN_PRODUCTS_FAIL = "GET_ADMIN_PRODUCTS_FAIL";

export const POST_ADMIN_PRODUCTS_REQUEST = "POST_ADMIN_PRODUCTS_REQUEST";
export const POST_ADMIN_PRODUCTS_SUCCESS = "POST_ADMIN_PRODUCTS_SUCCESS";
export const POST_ADMIN_PRODUCTS_FAIL = "POST_ADMIN_PRODUCTS_FAIL";